
import axios from 'axios';
import { api } from '../../api'
import getToken from '../../hook/getToken';

export const GET_DATA = "GET_DATA"
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS'
export const GET_DATA_FAILURE = 'GET_DATA_FAILURE'

export const get_data = () => ({ type: GET_DATA })
export const get_data_success = (data) => ({ type: GET_DATA_SUCCESS, payload: data, })
export const get_data_failure = () => ({ type: GET_DATA_FAILURE })


export function all_data() {
    return async dispatch => {
        dispatch(get_data());
        try {
            const res = await axios.get(`${api}/lesson/index.php`, {
                headers: {
                    'Authorization': getToken('accessToken'),
                }
            });
            // if(res.data.status === 0) return window.location.reload()
            const data = res.data.data;
            dispatch(get_data_success(data));
        } catch (error) {
            dispatch(get_data_failure());
        }
    };
}

export async function deleteRecord(value) {
    let res = await axios.get(`${api}/lesson/index.php?delete_id=${value}`, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function updateLessonStatus(id, status) {
    console.log(status)
    let updatedStatus = status ? false : true
    let res = await axios.get(`${api}/lesson/index.php?id=${id}&status=${updatedStatus}`, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function getData(value) {
    let res = await axios.get(`${api}/lesson/index.php?lesson_id=${value}`,{
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}


export async function addLesson(data) {
    let res = await axios.post(`${api}/lesson/index.php`, data, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function editLesson(data) {
    let res = await axios.post(`${api}/lesson/update.php`, data, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}

export async function lessonDropdown(data) {
    let res = await axios.get(`${api}/lesson/index.php?dropdown=true`, {
        headers: {
            'Authorization': getToken('accessToken'),
        }
    })
    if(res.data.status === 0) return window.location.reload()
    return res.data;
}


export async function getSession() {
    try {
        let res = await axios.get(`${api}/sessions/index.php?checkSession=true`,{
            headers: {
                'Authorization': getToken('accessToken'),
            }
        })
        console.log(res.data)
        
        return res.data.status;
    } catch (error) {
        return false;
    }
}

export async function createSession(value) {
        let res = await axios.post(`${api}/sessions/index.php`, JSON.stringify(value))
        return res.data;
}



